import { mainAPI, handleApiError } from "../api";
import {
  AdsResponse,
  AdsListRequest,
  AdsBlockedRequest,
} from "../types/api/ads";
import { ApiErrorResponse } from "../types/api/error";

const path = `/ads/admin/${process.env.REACT_APP_API_VERSION}`;

// Объявление пользователя - Получить
export function fetchAds(adId: string) {
  return mainAPI.get(`${path}/${adId}`).then(
    (res) => {
      return Promise.resolve(res.data as AdsResponse);
    },
    (error) => handleApiError(error)
  );
}

// Объявления пользователей - Получить список
export function fetchAdsList(params: AdsListRequest = {}) {
  return mainAPI.post<AdsResponse[]>(`${path}/feed`, params).then(
    (res) => {
      const countHeader = res.headers["count"];
      return Promise.resolve({
        list: res.data,
        totalCount: countHeader,
      });
    },
    (error) => handleApiError(error)
  );
}

// Объявление пользователя - Заблокировать
// Перевести ожидающее WAITING в отклонённое REJECTED (по ТЗ удалить объявления нуждающиеся в модерации)
export function blockAd(ids: string[]) {
  return mainAPI.post(`${path}/block`, { ids }).then(
    (res) => {
      return Promise.resolve(res.data as AdsResponse);
    },
    (error) => handleApiError(error)
  );
}

// Объявления пользователей - Активировать
// Активировать архивированные и нуждающиеся в модерации пачкой, кроме status=CONFIRMED
export function activateAds(ids: string[]) {
  return mainAPI.post(`${path}/activate`, { ids }).then(
    (res) => {
      return Promise.resolve(res.data as AdsResponse);
    },
    (error) => handleApiError(error)
  );
}

// Объявления пользователей - Вернуть в работу
// Перевести отклонённое REJECTED (в том числе антифродом) в CONFIRMED
export function restoreAds(ids: string[]) {
  return mainAPI.post(`${path}/restore`, { ids }).then(
    (res) => {
      return Promise.resolve(res.data as AdsResponse);
    },
    (error) => handleApiError(error)
  );
}

// Объявления пользователей - Отклонить
// Перевести ожидающее WAITING в отклонённое REJECTED (по ТЗ удалить объявления требующие подтверждения)
export function declineAds(ids: string[]) {
  return mainAPI.post(`${path}/decline`, { ids }).then(
    (res) => {
      return Promise.resolve(res.data as AdsResponse);
    },
    (error) => handleApiError(error)
  );
}

// Объявления пользователей - Получить список заблокированных
// Объявления с status=WAITING из анти фрода или по методу /decline
export function fetchWaitingAds(params: AdsBlockedRequest) {
  return mainAPI.post<AdsResponse[]>(`${path}/waiting`, params).then(
    (res) => {
      const countHeader = res.headers["count"];
      return Promise.resolve({
        list: res.data,
        totalCount: countHeader,
      });
    },
    (error) => handleApiError(error)
  );
}

//Объявления пользователей - Экспортировать
export function exportAds() {
  return mainAPI.post(`${path}/export`, {}, { responseType: "blob" }).then(
    (res) => {
      return Promise.resolve(res.data);
    },
    (error) => {
      const apiError: ApiErrorResponse = error.response?.data;
      return Promise.reject(
        new Error(apiError?.detail || "Ошибка при экспорте объявлений")
      );
    }
  );
}
